import {
  ADD_ONBOARDING_STEPS,
  NEXT_ONBOARDING_STEP,
  RESET_ONBOARDING_STEPS,
} from 'ActionTypes/onBoarding';
import {
  addStepsAndRestart, findNextStep, INITIAL_STEP,
} from './onBoarding.utils';

const initialState = {
  current: INITIAL_STEP,
  steps: [],
};

export const onBoardingReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case NEXT_ONBOARDING_STEP:
      return {
        ...state,
        current: findNextStep(state.steps, state.current),
      };
    case ADD_ONBOARDING_STEPS:
      return addStepsAndRestart(state, payload);
    case RESET_ONBOARDING_STEPS:
      return {
        ...state,
        current: null,
        started: false,
        steps: [],
      };
    default:
      return { ...state };
  }
};

export default onBoardingReducer;
